import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigApiService {
  constructor(private http: HttpClient) { }

  serverUrl = environment.serverUrl;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    return throwError('Something bad happened. Please try again later.');
  }

  // Récupérer toutes les configurations d'API
  getAllConfigApis(): Observable<any> {
    return this.http.get<any>(this.serverUrl + 'config_api/get_all', this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Ajouter une nouvelle configuration d'API
  addConfigApi(data: any): Observable<any> {
    return this.http.post<any>(this.serverUrl + 'config_api/add', data, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Mettre à jour une configuration d'API
  updateConfigApi(id: number, data: any): Observable<any> {
    return this.http.post<any>(this.serverUrl + 'config_api/update/' + id, data, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Supprimer une configuration d'API
  deleteConfigApi(id: number): Observable<any> {
    return this.http.post<any>(this.serverUrl + 'config_api/delete/' + id, {}, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Mettre à jour le statut (toggle)
  updateStatus(id: number, status: string): Observable<any> {
    return this.http.post<any>(this.serverUrl + 'config_api/update_status/' + id, { status }, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Récupérer les tokens d'une API
  getApiTokens(apiName: string): Observable<any> {
    return this.http.post<any>(this.serverUrl + 'config_api/get_tokens', { api_name: apiName }, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Tester l'envoi d'une alerte Pennylane
  sendPennylaneTestAlert(): Observable<any> {
    return this.http.post<any>(this.serverUrl + 'pennylane/send_test_health_alert', {}, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
}

